import { Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/guards/auth.guard";

export const BannersRoutes: Routes = [
  {
    path: "banners",
    loadComponent: () =>
      import("./banners/banners.component").then((m) => m.BannersComponent),
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./banners-list/banners-list.component").then(
            (m) => m.BannersListComponent,
          ),
      },
      {
        path: "add",
        loadComponent: () =>
          import("./banner-form/banner-form.component").then(
            (m) => m.BannerFormComponent,
          ),
      },
      {
        path: "view/:id",
        loadComponent: () =>
          import("./banner-form/banner-form.component").then(
            (m) => m.BannerFormComponent,
          ),
      },
    ],
  },
];
